import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { HallPass } from '../../../../../models/HallPass';
import * as futurePassesActions from '../actions';
import { IFuturePassesState } from '../states';

export const adapter: EntityAdapter<HallPass> = createEntityAdapter<HallPass>();

export const futurePassesInitialState: IFuturePassesState = adapter.getInitialState({
	loading: false,
	loaded: false,
});

const reducer = createReducer(
	futurePassesInitialState,
	on(futurePassesActions.getFuturePasses, (state) => ({ ...state, loading: true, loaded: false })),
	on(futurePassesActions.getFuturePassesSuccess, (state, { futurePasses }) => {
		return adapter.setAll(futurePasses, { ...state, loading: false, loaded: true });
	})
);

export function futurePassesReducer(state: any | undefined, action: Action) {
	return reducer(state, action);
}
